import { FC } from 'react'
import Button from 'components/forms/Button'
import Link from 'next/link'
import { Tenant } from 'common/tenant'

type Props = {
  tenant?: Tenant
}

const InnovationRecognitionSummary: FC<Props> = ({ tenant = Tenant.UK }) => {
  return (
    <div
      className='d-flex flex-column align-self-center'
      style={{
        maxWidth: 1005,
      }}
    >
      <h2 className='fw-semibold fs-fluid-36-80 lh-105 text-center mb-6'>
        Recognised for <div className='color-pink2'>Innovation</div>
      </h2>
      <h3 className='text-center fs-fluid-18-36 lh-140 fw-semibold color-grey5 mb-3 mb-lg-10 px-4 px-lg-0 fs-fluid-18-36'>
        Our commitment to innovation and entrepreneurship has been recognised on
        numerous occasions.
      </h3>
      <p className='lh-140 fw-semibold fs-fluid-16-24'>
        Most notably, our directors were invited to a prestigious Buckingham
        Palace Reception celebrating UK Innovation and Entrepreneurship,
        highlighting our impact on the industry.
        <br />
        <br />
        In 2024, our CEO was voted{' '}
        <a
          className='color-pink2'
          href='https://www.hoxtonmix.com/blog/beelieve-2024/'
          target='_blank'
          rel='noreferrer'
        >
          Founder of the Year
        </a>{' '}
        at the{' '}
        <a
          className='color-pink2'
          href='https://www.hoxtonmix.com/blog/beelieve-2024/'
          target='_blank'
          rel='noreferrer'
        >
          Beelievers Awards
        </a>
        , further recognising our leadership in driving innovation and scaling
        successful businesses.
        <br />
        <br />
        In 2025, we were selected as one of the top 100 UK businesses for
        exponential growth in the Innovate UK Scale-up Programme, recognising
        our potential for high-impact scaling.
        <br />
        <br />
        Additionally, we were invited to Y Combinator for our Virtual Office
        Software as a Service, showcasing the value and potential of our B2B and
        enterprise solutions in the global market.
      </p>
      <Link
        className='align-self-lg-center mt-2 mt-lg-3'
        href={tenant === Tenant.AU ? '/au/about-us' : '/about-us'}
      >
        <Button className='px-22 w-100 w-lg-auto' theme='black'>
          About Us
        </Button>
      </Link>
    </div>
  )
}

export default InnovationRecognitionSummary
